<template>
    <v-container class="pa-5" fluid>
        <page-title>Raportowanie papieru / Raporty szczegółowe</page-title>

        <v-container>
            <v-row align="center">
                <v-col class="pb-0">
                    <v-btn
                        text
                        color="primary"
                        class="pa-0"
                        @click="close"
                    >
                        <v-icon color="primary">
                            mdi-arrow-left
                        </v-icon>
                        Powrót do listy
                    </v-btn>
                </v-col>
            </v-row> 
            <v-row>
                <v-col cols="12">
                    <ReportTimerTracker
                        :report="report"
                        :task-name="taskName"
                        :delay="delay"
                        :duration="duration"
                        :time-without-limit="timeWithoutLimit"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <ReportParametersData
                        :report-data="report"
                    />
                </v-col>
                <v-col cols="12" md="6">
                    <PaperPalletReport
                        :pallets-list="report.reportPallets"
                        :report-id="report.id"
                    />
                </v-col>
            </v-row>
            <v-row>
                <NextScheduledTasks                             
                    :limit="isOffsetPrintSite ? 3 : 1"
                    :is-printing="isOffsetPrintSite" 
                />
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import NextScheduledTasks from '../Common/NextScheduledTasks'
import PageTitle from '@/components/common/PageTitle'
import PaperPalletReport from './PaperPalletReport'
import ReportParametersData from '../Common/ReportParametersData'
import ReportTimerTracker from '../Common/ReportTimerTracker'
import store from '@/store'

export default {
    name: 'DetailedPaperReports',
    components: {
        PageTitle,
        PaperPalletReport,
        NextScheduledTasks,
        ReportParametersData,
        ReportTimerTracker
    },
    beforeRouteEnter(to, from, next) {
        if (to.params.id) {
            Promise.all([
                store.dispatch('reports/getReport', to.params.id),
                store.dispatch('reports/getTaskNames')
            ])
                .then(([reportData, taskNames])=> {
                    next(vm => {
                        vm.taskNames = taskNames.data.results
                        vm.taskName = vm.taskNames.find(item => item.id === reportData.objectType).name
                        vm.report = reportData
                        if (!vm.isReportFinished) vm.setDuration()
                    })
                })
                .catch(error => {
                    errorHandler(error)
                    next(false)
                })
        } else {
            next()
        }
    },
    data() {
        return {
            taskName: null,
            taskNames: [],
            delay: 0,
            duration: null,
            intervalId: null,
            remainingTime: null,
            timeWithoutLimit: 0,
            report: {
                statusId: null,
                objectDetail: {
                    reportItemPlateParameters: []
                },
                reportPallets: [],
                comments: []
            },
        }
    },
    computed: {
        isReportFinished() {
            return this.report?.statusId == 99
        },
        workspaceSettings() {
            const workspace = localStorage.getItem('workspace')

            return JSON.parse(workspace)
        },
        isOffsetPrintSite() {
            if (!this.workspaceSettings.workspaceTypeId) return
            
            return this.workspaceSettings.workspaceTypeId === 7
        },
    },
    methods: {
        setDuration() {
            const timeElapsed = Math.floor((this.report.remainingTime) / 1000)

            this.report.remainingTime == null ? this.remainingTime = 0 : this.remainingTime = this.report.remainingTime

            if (timeElapsed >= this.remainingTime) { // przekroczono czas wykonania = jest opoznienie lub nie ma limitu
                this.report.remainingTime == null ? this.timeWithoutLimit = timeElapsed : this.delay = Math.floor(timeElapsed - this.remainingTime)
                this.duration = -1
            }
            if (timeElapsed < this.remainingTime) { // miescimy sie w czasie
                this.duration = Math.floor(this.remainingTime - timeElapsed)
            }
            if (this.report.statusId === 1) {
                this.refreshDuration()
                this.intervalId = setInterval(this.refreshDuration, 1000)
            }
        },
        refreshDuration() {
            if (this.duration >= 0) {
                this.duration -= 1
            }
            if (this.duration == -1) {
                this.report.remainingTime == null ? this.timeWithoutLimit += 1 : this.delay += 1
            }
        },
        close() {
            this.$router.push({ name: 'reportsPaperReportingPaperReporting' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    },
}
</script>